import { Form,Button, Col, Row } from "react-bootstrap";
export default function TablePackageNormalPremium({ 
    simulate, 
    packagePeriod, 
    handleSetSimulatePremiums, 
    calculatePrice, 
    mode, 
    calculatedPrices}){
return(
    <>
        <Row className='mb-5'>
            <Col className="me-3">
                <div>
                    <Form.Label className='label-title'>รายละเอียดราคา</Form.Label>
                </div>
                <div>
                    <Button 
                        variant="outline-secondary" 
                        type="button" 
                        className=''
                        disabled={mode === 'view'}
                        onClick={event => calculatePrice ()}
                    >
                        คํานวณราคา
                        <i className="fa-solid fa-calculator ms-2"></i>
                    </Button>
                </div>
                    <table cellPadding={4} className="table">
                        <thead>
                            <tr>
                                <th>ระยะเวลาแพ็กเกจ</th>
                                <th>ราคา</th>
                                <th>ใช้งาน</th>
                            </tr>
                        </thead>
                        <tbody>
                            {packagePeriod?.map((obj, index) => (
                                <tr  key={index}>
                                    <td>{obj.name}</td>
                                    <td > 
                                        <Form.Control
                                            type="text"
                                            name={`total|${obj.id}`}
                                            plaintext={mode === 'view'}
                                            readOnly={mode === 'view'}
                                            className="w-100"
                                            value={simulate.arr_premium?.find(x => x.master_period_id === obj.id)?.total ?? calculatedPrices[index]}
                                            onChange={handleSetSimulatePremiums}
                                            placeholder={"รายละเอียดราคา"}
                                            required
                                        />
                                    </td>
                                    <td>
                                        <Form.Switch 
                                            name={`active|${obj.id}`}
                                            className="ms-0"
                                            disabled={(mode === 'view') ? true : false}
                                            checked={simulate?.arr_premium?.find(x => x.master_period_id === obj.id)?.active ?? false}
                                            placeholder="ใช้งาน" 
                                            onChange={handleSetSimulatePremiums} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
            </Col>
        </Row>
    </>
    );
}